<template>
  <div style="padding: 10px">
    <x-table
      listApi="biz.warehouse.goods.info.listBySku"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无库存信息"
      :paramList="paramList"
      :fieldList="fieldList"
      :actionList="actionList"
      :defaultParams="defaultParams"
      :actionWidth="100"
    >
      <template slot="row-info" slot-scope="scope">
        <warehouse-goods-info
          :goodsInfo="scope.row"
          :showInfo="false"
          :showImage="false"
          :showConsume="true"
        />
      </template>
    </x-table>
  </div>
</template>

<script>
import detailPage from "../../warehouse/warehouse-goods/detail.vue";
import warehouseGoodsInfo from "../../../../components/business/warehouseGoodsInfo.vue";

export default {
  components: {
    warehouseGoodsInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        skuGuid: this.pageQuery.guid,
        minStock: 0.01,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      paramList: [
        {
          label: "过滤显示",
          type: "select",
          field: ["minStock"],
          styleValue: "width: 160px",
          options: [
            {
              label: "全部门店",
              value: "0",
            },
            {
              label: "库存大于0的门店",
              value: "0.01",
            },
          ],
          default: "0",
        },
      ],
      fieldList: [
        {
          label: "库存信息",
          minWidth: "220",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "商品信息详情",
              refresh,
              component: detailPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
      ],
    };
  },
};
</script>
